export default function Footer() {
  return (
    <a className="footer-text" href="https://www.medicaldirectorco.com" target="__blank">
      Powered by Medical Director Co.
    </a>
  );
}
